module.exports = __webpack_public_path__ + "img/高亮网络2.f0e77386.svg";